import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-mobile-login',
  templateUrl: './mobile-login.component.html',
  styleUrls: ['./mobile-login.component.css']
})
export class MobileLoginComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
  ) { 
    if(!this.commonService.getIsMobile()) {
      this.router.navigate(['/login'])
    }
  }
  
  isShowEventBanner: boolean = moment().isBefore(moment('2025-05-31 00:00:00'))
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl']
    })
    let user: User = this.commonService.getUserInfo()
    if(user) {
      window.scrollTo(0, 0);
      this.router.navigate(['/m/mypage'])
    }
    this.check()
  }
  returnUrl: string
  userId: string
  password: string
  isActive: boolean = false
  login(){
    if (!this.userId || this.userId.length < 1) {
      alert('아이디를 입력해주세요');
      return;
    }
    
    if (!this.password || this.password.length < 1) {
      alert('패스워드를 입력해주세요.');
      return;
    }

    this.authService.login(this.userId, this.password).subscribe(res => {
      if(res.resultCode) {
        alert(res.message)
      } else {
        let accessToken = res.accessToken
        let refreshToken = res.refreshToken
        this.authService.saveToken(accessToken, refreshToken)
        if(this.returnUrl){
          window.scrollTo(0, 0);
          this.router.navigate([this.returnUrl])
        } else {
          window.scrollTo(0, 0);
          this.router.navigate(['/m/mypage'])
        } 
      }
    });
  } 
  
  check() {
    this.isActive = false
    if(this.userId && this.password) {
      this.isActive = true
    }
  }
}
